import * as types from "../../constants";

import {
  resetPassword as authResetPassword,
  signUp as authSignUp,
  internalAuthSignInPortAuth,
  externalAuthSignInCitizen,
  dummyInternalAuthSignInPortAuth,
} from "../../services/authService";

import ls from "local-storage";
import axios from "../../utils/axios";

// sign in for port authorities with their service
export function internalSignInPortAuth(code) {
  return async (dispatch) => {
    dispatch({ type: types.AUTH_SIGN_IN_REQUEST });
    return internalAuthSignInPortAuth(code)
      .then(({ user, accessToken }) => {
        dispatch({
          type: types.AUTH_SIGN_IN_SUCCESS,
          username: user.username,
          id: user.id,
          auth_level: user.auth_level,
          port_auth_id: user.port_auth_id,
          port_auth: user.port_auth,
          accessToken: accessToken,
        });
        ls("username", user.username);
        ls("id", user.id);
        ls("auth_level", user.auth_level);
        ls("port_auth_id", user.port_auth_id);
        ls("port_auth", user.port_auth);
        ls("accessToken", accessToken);

        if (accessToken) {
          axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
        }
      })
      .catch((error) => {
        dispatch({ type: types.AUTH_SIGN_IN_FAILURE });
        throw error;
      });
  };
}

export function dummyInternalSignInPortAuth(code) {
  // console.log("dummyInternalSignInPortAuth before 1 " + code);
  return async (dispatch) => {
    dispatch({ type: types.AUTH_SIGN_IN_REQUEST });
    return dummyInternalAuthSignInPortAuth(code)
      .then(({ user, accessToken }) => {
        // console.log("dummyInternalSignInPortAuth then " + code);
        dispatch({
          type: types.AUTH_SIGN_IN_SUCCESS,
          username: user.username,
          id: user.id,
          auth_level: user.auth_level,
          port_auth_id: user.port_auth_id,
          port_auth: user.port_auth,
          accessToken: accessToken,
        });
        ls("username", user.username);
        ls("id", user.id);
        ls("auth_level", user.auth_level);
        ls("port_auth_id", user.port_auth_id);
        ls("port_auth", user.port_auth);
        ls("accessToken", accessToken);

        if (accessToken) {
          axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
        }
      })
      .catch((error) => {
        // console.log("dummyInternalSignInPortAuth error " + error)
        console.log(error, "kappa");
        dispatch({ type: types.AUTH_SIGN_IN_FAILURE });
        throw error;
      });
  };
  // console.log("dummyInternalSignInPortAuth end " + code);
}

// sign in for taxis user
export function externalSignInTaxis(code) {
  return async (dispatch) => {
    dispatch({ type: types.AUTH_SIGN_IN_REQUEST });
    return externalAuthSignInCitizen(code)
      .then(({ user, accessToken }) => {
        dispatch({
          type: types.AUTH_SIGN_IN_SUCCESS,
          username: user.id,
          afm: user.afm,
          id: user.id,
          auth_level: user.auth_level,
          port_auth_id: user.port_auth_id, // TO BE DELETED FOR PRODUCTION and replaced with actual value
          port_auth: user.port_auth, // TO BE DELETED FOR PRODUCTION and replaced with actual value
          accessToken: accessToken,
          gdpr_accept: user.gdpr_accept,
          birthyear: user.birthyear,
          fathername: user.fathername,
          firstname: user.firstname,
          lastname: user.lastname,
          mothername: user.mothername,
          amka_verified: user.amka_verified,
        });

        ls("username", user.id);
        ls("afm", user.afm);
        ls("id", user.id);
        ls("auth_level", user.auth_level);
        ls("port_auth_id", user.port_auth_id); // TO BE DELETED FOR PRODUCTION and replaced with actual value
        ls("port_auth", user.port_auth); // TO BE DELETED FOR PRODUCTION and replaced with actual value
        ls("accessToken", accessToken);
        ls("gdpr_accept", user.gdpr_accept);
        ls("amka_verified", user.amka_verified);
        ls("birthyear", user.birthyear);
        ls("fathername", user.fathername);
        ls("firstname", user.firstname);
        ls("lastname", user.lastname);
        ls("mothername", user.mothername);

        if (accessToken) {
          axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
        }
      })
      .catch((error) => {
        dispatch({ type: types.AUTH_SIGN_IN_FAILURE });
        throw error;
      });
  };
}

// update user port auth
export function updateUserPorthAuth(port_auth) {
  return async (dispatch) => {
    dispatch({
      type: types.UPDATE_USER_PORT_AUTH,
      port_auth: port_auth,
    });

    ls("port_auth", port_auth);
  };
}

export function signUp(credentials) {
  return async (dispatch) => {
    dispatch({ type: types.AUTH_SIGN_UP_REQUEST });

    return authSignUp(credentials)
      .then((response) => {
        dispatch({
          type: types.AUTH_SIGN_UP_SUCCESS,
          id: response.id,
          email: response.email,
          name: response.name,
        });
      })
      .catch((error) => {
        dispatch({ type: types.AUTH_SIGN_UP_FAILURE });
        throw error;
      });
  };
}

export function signOut() {
  return async (dispatch) => {
    dispatch({
      type: types.AUTH_SIGN_OUT,
    });
  };
}

export function resetPassword(credentials) {
  return async (dispatch) => {
    dispatch({ type: types.AUTH_RESET_PASSWORD_REQUEST });

    return authResetPassword(credentials)
      .then((response) => {
        dispatch({
          type: types.AUTH_RESET_PASSWORD_SUCCESS,
          email: response.email,
        });
      })
      .catch((error) => {
        dispatch({ type: types.AUTH_RESET_PASSWORD_FAILURE });
        throw error;
      });
  };
}
